import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Home from "./components/Home";
import SearchForm from "./components/SearchForm";
import AppHeader from "./components/AppHeader";
import { AuthProvider } from "./context/AuthContext";
import { DeckProvider } from "./context/DeckContext";
import DeckBuilder from "./pages/DeckBuilder";
import SearchResults from "./pages/SearchResults";

const AppContent = () => {
  const location = useLocation();
  const isDeckRoute = location.pathname.startsWith("/deck");

  return (
    <div className={isDeckRoute ? "app-shell app-shell-deck" : "app-shell"}>
      <AppHeader />
      {location.pathname === "/" ? <SearchForm /> : null}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/deck" element={<DeckBuilder />} />
      </Routes>
    </div>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <DeckProvider>
        <AppContent />
      </DeckProvider>
    </AuthProvider>
  );
};

export default App;
